import { Combobox as BaseCombobox } from '@base-ui/react';
import { useMemo } from 'react';

export const useItems: typeof BaseCombobox.createItems = (data, options) => {
  return useMemo(() => BaseCombobox.createItems(data, options), [data, options]);
};
